module.exports = __webpack_public_path__ + "media/fail.4d289a7a.mp3";